/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-01T19:13:36.235
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getConDeputeContractBackSettlementEditInit,
	getConDeputeContractBackSettlementView
} from '@api/storagemanage/ConDeputeContractBackSettlement';

import {
listConDeputeContractBackSettlementItemInit,
listConDeputeContractBackSettlementItemByAuthorizations,
deleteConDeputeContractBackSettlementItem
} from '@api/storagemanage/ConDeputeContractBackSettlementItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getConDeputeContractBackSettlementEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getConDeputeContractBackSettlementEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getConDeputeContractBackSettlementView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getConDeputeContractBackSettlementView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
